import styled from "styled-components"
import { media } from "../../../../styles"

import { Link } from "gatsby"

export const MobileMenuContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 800;
  height: 100vh;
  width: 100vw;

  padding: 20% 0;

  background-image: var(--header-home-gradient);

  display: ${prop => (prop.open ? "flex" : "none")};

  align-items: center;
  justify-content: center;
`
export const MobileMenuList = styled.ul`
  list-style: none;
  text-align: center;
`

export const MobileMenuItem = styled.li`
  margin: 5rem 0;

  font-size: var(--font-size-nav-item);
  font-family: var(--font-body);
  color: var(--color-white);

  text-transform: uppercase;
  cursor: pointer;
`

export const MobileMenuLink = styled(Link)`
  color: var(--color-white);

  max-height: 3rem;
`

export const MobileMenuBtn = styled.div`
  position: fixed;
  z-index: 999;

  width: 4rem;
  height: 2.5rem;

  top: 3.7rem;
  right: 5rem;
  cursor: pointer;

  display: none;

  ${media.laptop`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  `}

  ${media.phone`
  right: 4rem;
  `}

  ${media.phonesmall`
  right: 2rem;
  top: 2.7rem;
  width: 3rem;
  `}
`

export const MobileMenuBtnLine = styled.div`
  width: 100%;
  height: 0.3rem;
  background-color: var(--color-white);
`
